import React, { useEffect, useState, useCallback } from "react";
import { Button, Collapse, Radio, Spin, Empty, Typography } from "antd";
import { ReloadOutlined, LeftOutlined } from "@ant-design/icons";
import s from "../mobile.module.css";
import moment from "moment";
import { instance } from "../../../API/API";
import { get_cookie } from "../../new_planning/helpers/helper";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const hash = get_cookie("hash");

const OldReports = ({ object, onClose, onEditReport, reportsTemp }) => {
    const [oldReports, setOldReports] = useState([]);
    const [days, setDays] = useState(7);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchOldReports = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const start = moment().subtract(days, 'days').format('X');
            const end = moment().format('X');

            const response = await instance.get(
                `reports/get_reports.php?object_id=${object.id}&start=${start}&end=${end}&api-key=${hash}`
            );

            if (response.data?.reports) {
                setOldReports(response.data.reports);
            } else {
                setOldReports([]);
            }
        } catch (err) {
            setError("Ошибка при загрузке отчетов");
            console.error("Error fetching old reports:", err);
        } finally {
            setLoading(false);
        }
    }, [days, object.id]);

    useEffect(() => {
        fetchOldReports();
    }, [fetchOldReports]);

    const getWorkNameById = useCallback((id) => {
        const work = reportsTemp.find(item =>
            Number(id) === Number(item.id)
        );
        return work?.name || "Неизвестная работа";
    }, [reportsTemp]);

    const renderReportContent = useCallback((report) => {
        const works = report.works_id?.split(',') || [];
        const comments = report.comments_id?.split('`') || [];

        return works.map((workId, index) => (
            <div key={`${workId}-${index}`} className={s.work__cont}>
                <Text strong className={s.oldreport_workname}>
                    {getWorkNameById(workId)}
                </Text>
                {comments[index] && (
                    <Text type="secondary" className={s.oldreport_comment}>
                        {comments[index]}
                    </Text>
                )}
            </div>
        ));
    }, [getWorkNameById]);

    const handlePeriodChange = (e) => {
        setDays(Number(e.target.value));
    };

    if (error) {
        return (
            <div className={s.oldreport_cont}>
                <div className={s.error_container}>
                    <Text type="danger">{error}</Text>
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={fetchOldReports}
                        style={{ marginTop: 16 }}
                    >
                        Повторить
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className={s.oldreport_cont}>
            <div className={s.header_1}>
                <Title level={4} className={s.title}>
                    Отчеты по: {object.name}
                </Title>
                {object.long_name && (
                    <Text type="secondary" className={s.subtitle}>
                        {object.long_name}
                    </Text>
                )}
            </div>

            <div className={s.controls}>
                <Radio.Group
                    onChange={handlePeriodChange}
                    value={days.toString()}
                    size="small"
                    buttonStyle="solid"
                >
                    <Radio.Button style={
                        {
                            color: '#fff',
                            background: '#ffffff'
                        }
                    } value="7">Неделя</Radio.Button>
                    <Radio.Button style={
                        {
                            color: '#fff',
                            background: '#ffffff'                        }
                    } type={'primary'} value="30">Месяц</Radio.Button>
                    <Radio.Button style={
                        {
                            color: '#fff',
                            background: '#ffffff'                        }
                    } type={'primary'} value="180">Полгода</Radio.Button>
                </Radio.Group>
            </div>

            {loading ? (
                <div className={s.loading_container}>
                    <Spin size="large" />
                    <Text>Загрузка отчетов...</Text>
                </div>
            ) : oldReports.length > 0 ? (
                <Collapse
                    accordion
                    className={s.reports_collapse}
                    expandIconPosition="end"
                >
                    {oldReports.map((report, index) => (
                        <Panel
                            key={report.id || index}
                            header={
                                <div className={s.panel_header}>
                                    <Text strong>
                                        {moment(Number(report.time_download) * 1000).format('LL')}
                                    </Text>
                                    <Text type="secondary">
                                        {moment(Number(report.time_download) * 1000).fromNow()}
                                    </Text>
                                </div>
                            }
                        >
                            <div className={s.report_content}>
                                {renderReportContent(report)}
                            </div>
                        </Panel>
                    ))}
                </Collapse>
            ) : (
                <Empty
                    description="Нет отчетов за выбранный период"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            )}

            <Button
                icon={<LeftOutlined />}
                onClick={onClose}
                type="primary"
                block
            >
                Назад
            </Button>
        </div>
    );
};

export default OldReports;